import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { requestTsrAdminOtp, verifyTsrAdminOtp } from '../../api/tsrAdminApi';
import { isTsrAdminAuthenticated } from '../../auth/tsrAdminAuth';

function TsrAdminLoginPage() {
  const navigate = useNavigate();
  const [otp, setOtp] = useState('');
  const [maskedEmail, setMaskedEmail] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [sending, setSending] = useState(false);
  const [verifying, setVerifying] = useState(false);

  useEffect(() => {
    if (isTsrAdminAuthenticated()) {
      navigate('/tsr-admin/home', { replace: true });
    }
  }, [navigate]);

  const handleSendOtp = async () => {
    try {
      setSending(true);
      setError('');
      setMessage('');
      const response = await requestTsrAdminOtp();
      setMaskedEmail(response?.data?.maskedEmail || '');
      setMessage(response?.message || 'OTP sent successfully.');
    } catch (err) {
      setError(err.message || 'Unable to send OTP.');
    } finally {
      setSending(false);
    }
  };

  const handleVerify = async (event) => {
    event.preventDefault();
    try {
      setVerifying(true);
      setError('');
      await verifyTsrAdminOtp(otp.trim());
      navigate('/tsr-admin/home', { replace: true });
    } catch (err) {
      setError(err.message || 'Invalid OTP.');
    } finally {
      setVerifying(false);
    }
  };

  return (
    <div className="container py-5" style={{ maxWidth: 480 }}>
      <div className="card border-0 shadow-sm rounded-4">
        <div className="card-body p-4">
          <h4 className="mb-2">TSR Admin</h4>
          <p className="text-muted mb-4">Sign in with a one-time password sent to the configured admin email.</p>

          {error ? <div className="alert alert-danger py-2">{error}</div> : null}
          {message ? <div className="alert alert-success py-2">{message}</div> : null}

          <button
            type="button"
            className="btn btn-primary w-100 mb-3"
            onClick={handleSendOtp}
            disabled={sending}
          >
            {sending ? 'Sending OTP...' : 'Send OTP'}
          </button>

          {maskedEmail ? <p className="small text-muted mb-3">OTP sent to: {maskedEmail}</p> : null}

          <form onSubmit={handleVerify}>
            <label className="form-label">Enter OTP</label>
            <input
              type="text"
              className="form-control mb-3"
              placeholder="6-digit code"
              value={otp}
              onChange={(event) => setOtp(event.target.value)}
              maxLength={6}
            />
            <button type="submit" className="btn btn-outline-primary w-100" disabled={verifying || otp.trim().length !== 6}>
              {verifying ? 'Verifying...' : 'Verify & Login'}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}

export default TsrAdminLoginPage;
